import {
  Button,
  Col,
  Form,
  message,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { SendOutlined } from "@ant-design/icons/lib/icons";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { columns } from "../constants/data/AllBatchesTables/editPendingBatchTable";
import * as ROUTES from "../constants/routes";
import {
  fetchBatchVendorsList,
  fetchPendingBatchItems,
  processPendingBatch,
} from "../redux/actions/allBatchActions/batchEditPendingActions";
import { useNavigate, useLocation } from "react-router-dom";
import arrowLeft from "../assets/svg/arrowLeft.svg";
import EditPendingBatchFilterForm from "../components/forms/batchForms/batchManagementFilterForms/EditPendingBatchFilterForm";
import { setBatchStatus } from "../utilities/helper";
import {
  DEFAULT_TABLE_PAGINATION_DROPDOWN_PAGE_COUNT,
  PAGES_CODE as PAGES,
} from "../constants/pages";
import {
  globalPagesFilterData,
  globalPagesPagination,
} from "../redux/actions/globalReducActions";
import {
  CaretLeftOutlined,
  CaretRightOutlined,
  DownOutlined,
} from "@ant-design/icons";
import {
  GLOBAL_PAGES_ACTIVE_FILTER_DEFAULT_STATE,
  GLOBAL_PAGES_PAGINATION_DEFAULT_STATE,
} from "../redux/reducers/globalDefaultStates";
import { TableDropdown } from "../components/common/TableDropDown";

const EditPendingBatchScreen = () => {
  const [list, setList] = useState({});
  const [loading, setLoading] = useState(false);
  const [currencyCode, setCurrencyCode] = useState("");
  const [status, setStatus] = useState("");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [vendorList, setVendorList] = useState([]);

  const idArr = location.search.split("");
  idArr.shift();
  const id = idArr.join("");
  const tablePaginationParams = useSelector(
    (state) =>
      get(state, "global.globalPagesPagination")[PAGES.BATCH_ITEMS_PENDING]
  );
  const activeFilters = useSelector(
    (state) =>
      get(state, "global.globalPagesFilterData")[PAGES.BATCH_ITEMS_PENDING]
  );
  const setTablePaginationParams = (param) => {
    if (param && typeof param == "function") {
      dispatch(
        globalPagesPagination(
          PAGES.BATCH_ITEMS_PENDING,
          param(tablePaginationParams)
        )
      );
    } else {
      dispatch(globalPagesPagination(PAGES.BATCH_ITEMS_PENDING, param));
    }
  };
  const setActiveFilters = (param) => {
    if (param && typeof param == "function") {
      dispatch(
        globalPagesFilterData(PAGES.BATCH_ITEMS_PENDING, param(activeFilters))
      );
    } else {
      dispatch(globalPagesFilterData(PAGES.BATCH_ITEMS_PENDING, param));
    }
  };
  useEffect(() => {
    getPendingBatchItems();
    batchVendorsList();
  }, [tablePaginationParams]);
  const onClickEdit = (record) => {
    const batchId = get(record, "batch_id", "");
    const batchRecordNo = get(record, "batch_record_no", 0);
    navigate({
      pathname: ROUTES.EDIT_PENDING_BATCH_ITEM,
      search: `${batchId}+${batchRecordNo}`,
    });
  };

  const postPendingBatch = (pendingBatchId) => {
    setLoading(true);
    dispatch(processPendingBatch(pendingBatchId))
      .then((result) => {
        setLoading(false);
        message.success(get(result, "message", ""));
        navigate(ROUTES.BATCH_MANAGEMENT);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const onClickPost = () => {
    postPendingBatch(id);
  };

  // get vendors list
  const batchVendorsList = () => {
    dispatch(fetchBatchVendorsList(id)).then(({ data }) => {
      console.log("batch vendors list", data);
      setVendorList(data);
    });
  };

  const getPendingBatchItems = () => {
    setLoading(true);
    let params = {
      ...tablePaginationParams,
    };
    dispatch(fetchPendingBatchItems(id, params))
      .then((result) => {
        setStatus(get(result, "Batch.status", ""));
        setCurrencyCode(get(result, "Batch.currency_code", ""));
        setList(result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const setTableSortingParams = (field, order) => {
    setTablePaginationParams((prevState) => {
      return {
        ...prevState,
        sortBy: order ? field : undefined,
        sortDir: order ? (order === "ascend" ? "ASC" : "DESC") : undefined,
      };
    });
  };

  useEffect(() => {
    if (get(activeFilters, "batch_id") != id) {
      setActiveFilters({
        ...GLOBAL_PAGES_ACTIVE_FILTER_DEFAULT_STATE["BATCH_ITEMS_PENDING"],
        batch_id: id,
      });
      setTablePaginationParams({
        ...GLOBAL_PAGES_PAGINATION_DEFAULT_STATE["BATCH_ITEMS_PENDING"],
        filters: {
          ...GLOBAL_PAGES_ACTIVE_FILTER_DEFAULT_STATE["BATCH_ITEMS_ARCHIVED"],
          batch_id: id,
        },
      });
    }
  }, [id]);
  return (
    <div className="main-wrapper-div">
      <div>
        <h1 className="title">Batch Management </h1>
      </div>
      <div className="form-sub-heading">
        <div className="arrow-img">
          <img
            src={arrowLeft}
            alt=""
            onClick={() => navigate(ROUTES.BATCH_MANAGEMENT)}
          />
        </div>
        <h2
          className="sub-title arrow-sub-title-alingment"
          style={{ marginBottom: 10 }}
        >
          {`Batch - ${id}`}
        </h2>

        <div className="edit-batch-tag">{setBatchStatus(status)}</div>
      </div>
      <div className="add-button-container-post">
        <Button className="main-button" size="middle" onClick={onClickPost}>
          POST
          <SendOutlined />
        </Button>
      </div>
      <EditPendingBatchFilterForm
        form={form}
        id={id}
        setActiveFilters={setActiveFilters}
        setTablePaginationParams={setTablePaginationParams}
        tablePaginationParams={tablePaginationParams}
        activeFilters={activeFilters}
        vendorList={vendorList}
      />
      <div className="user-table" style={{ marginTop: -16 }}>
        <Table
          showSorterTooltip={false}
          rowKey="i"
          size="small"
          dataSource={get(list, "data", [])}
          rowClassName={(record) => `${record.status === "V" ? "voided" : ""}`}
          columns={columns({ onClickEdit, currencyCode, list })}
          onChange={(a, b, sorting) =>
            setTableSortingParams(sorting.field, sorting.order)
          }
          loading={loading}
          footer={() => (
            <Row justify={"space-between"}>
              <Col>
                <Space>
                  <TableDropdown
                    itemsArr={DEFAULT_TABLE_PAGINATION_DROPDOWN_PAGE_COUNT}
                    itemOnClick={setTablePaginationParams}
                    tablePaginationParams={tablePaginationParams}
                  />
                  <Typography>{`${get(list, "offset", 0) + 1} to ${
                    get(list, "data", []).length + get(list, "offset", "--")
                  } of ${get(list, "total", "--")} items`}</Typography>
                </Space>
              </Col>
              <Col>
                <Button.Group>
                  <Button
                    type="ghost"
                    icon={<CaretLeftOutlined />}
                    onClick={() =>
                      setTablePaginationParams({
                        ...tablePaginationParams,
                        offset: get(list, "offset", 0) - get(list, "limit", 0),
                      })
                    }
                    disabled={!get(list, "offset", 0)}
                  />
                  <Button
                    type="ghost"
                    icon={<CaretRightOutlined />}
                    onClick={() =>
                      setTablePaginationParams({
                        ...tablePaginationParams,
                        offset: get(list, "offset", 0) + get(list, "limit", 0),
                      })
                    }
                    disabled={
                      get(list, "offset", 0) + get(list, "limit", 0) >=
                      get(list, "total", 0)
                    }
                  />
                </Button.Group>
              </Col>
            </Row>
          )}
          scroll={{ y: "calc(100vh - 450px)", x: 1000 }}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default EditPendingBatchScreen;
